/** @format */
/* eslint-disable */ 
import Display from './display';
import Day from './day';
import { $csI18n } from '@/js/modules/csI18n';

export const $_standardMode = {
    /**
     * @public
     * @description
     * We will take the newly supplied date, decorate it into data that we can understand and use,
     * then if it's selectable then we will assign them to a dates array and return them. 
     * We will also update our display from the selected date to make sure we see the right month in
     * the calendar. 
     * Also, we will update the timestamp for the instance.
     * 
     * @param {Object} instance - the active datepicker instance
     * 
     * @returns {Array}
     */
	buildSelectedDatesFromDatestamp(instance) {
        const dates = [];
        const newDate = Day.getDateObjectFromDateString(instance.displayDateStamp, instance);
        instance = Display.updateCalendarViewFromDate(newDate, instance);
		
		let instanceOriginalDateObject = undefined;
		if (instance.originalDate != undefined && instance.originalDate != "") {
			instanceOriginalDateObject = Day.getDateObjectFromDateString(instance.originalDate, instance);
		}
		
        if (newDate.date.isSelectable || (instanceOriginalDateObject != undefined && instanceOriginalDateObject.date.jsDateRef === newDate.date.jsDateRef && !instance.initialised)) {
            dates.push(newDate);
            if (instance.displayDateStamp == undefined) {
                instance.displayDateStamp = newDate.date.jsDateRef;
            }
            return dates;
        } else {
			if (instanceOriginalDateObject != undefined && instanceOriginalDateObject.date.jsDateRef != newDate.date.jsDateRef) {
				//Error won't be thrown for non selectable dates as the ui will prevent it anyway
            	throw new Error($csI18n.t('datepicker.nonSelectableDate', [newDate.date.dateString]));
			}
			return dates;
        }
    },

    /**
     * 
     * @param {Object} dateSelected the newly selected date
     * @param {*} instance the active datepicker instance
     * 
     * * @returns {Object}
     */
    updateDisplayDateStamp(dateSelected, instance) {
        instance.displayDateStamp = dateSelected.date.jsDateRef
        return instance;
    }
};

export {$_standardMode as default};
